import script from "./ProcessoIncidentePje.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessoIncidentePje.vue?vue&type=script&setup=true&lang=js"

import "./ProcessoIncidentePje.vue?vue&type=style&index=0&id=30309ee3&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
